module.exports = __webpack_public_path__ + "img/Scott Pilgrim poster.00f04e76.png";